import { PropsWithChildren } from 'react';
import { HtmlPreview } from '@/components/ui/custom/dataDisplay/HtmlPreview';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { BuilderComposite } from '../types';
import { createAnswerResolver } from './createAnswerResolver';
import { answerMap } from './answersMap';

type StandardTitleProps = { title: string };
type StandardContextProps = { context: string };

function StandardTitle({ title }: StandardTitleProps) {
  return (
    <h2 className="w-full text-center font-700 text-primary text-xl text-wrap wrap-break-word">
      {title}
    </h2>
  );
}

function StandardContext({ context }: StandardContextProps) {
  return (
    <ConditionalRenderer condition={!!context}>
      <HtmlPreview
        html={context}
        format="default"
        className="w-full text-lg font-poppins px-4"
      />
    </ConditionalRenderer>
  );
}

function StandardBase({ children }: PropsWithChildren) {
  return (
    <div className="flex w-full flex-col items-center gap-6">{children}</div>
  );
}

export const standardBuilder: BuilderComposite = {
  Title: StandardTitle,
  Context: StandardContext,
  Base: StandardBase,
  Answer: createAnswerResolver(answerMap, 'standard'),
};
